import { ArrowUpRight } from "lucide-react";

export default function AffiliateCTA({ product, url }) {
  const destination = url || "#";
  return (
    <aside
      className="my-10 bg-indigo-50/70 border border-indigo-100 rounded-xl p-6 sm:p-7"
      data-testid={`affiliate-cta-${(product || "software").toString().toLowerCase().replace(/\s+/g, "-")}`}
    >
      <p className="eyebrow mb-2">Interested in this software?</p>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h4 className="font-playfair text-xl text-neutral-900">
            Explore {product} directly.
          </h4>
          <p className="text-sm text-neutral-600 mt-1 mb-0">
            Visit the product site to review current pricing, features, and plans.
          </p>
        </div>
        <a
          href={destination}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="inline-flex items-center gap-2 whitespace-nowrap no-underline px-5 py-2.5 rounded-full bg-indigo-800 text-surface text-sm font-semibold hover:bg-indigo-900 transition-colors"
          data-testid="affiliate-cta-button"
        >
          Visit {product} <ArrowUpRight size={15} />
        </a>
      </div>
      <p className="mt-4 mb-0 text-[11px] uppercase tracking-wider text-neutral-500">
        May contain affiliate links. See our affiliate disclosure.
      </p>
    </aside>
  );
}
